import { render, staticRenderFns } from "./DetailLoanDialog.vue?vue&type=template&id=13a6ec7e&"
import script from "./DetailLoanDialog.vue?vue&type=script&lang=js&"
export * from "./DetailLoanDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports